<template>
  <v-dialog persistent width="90%" v-model="active">
    <v-card class="rounded-sm" elevation="4">
      <v-card-title>
        <div class="text-h6">Evaluación de disciplina operativa</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card class="rounded-sm" elevation="4">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Información general</div>
                </v-card-title>
                <v-card-text>
                  <InformacionGeneralEvaluacionSection :evaluacion="disciplinaOperativa" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <ProcedimientosCountersSection :procedimientos="activeProcedimientos" />
            </v-col>
            <v-col>
              <ProcedimientosForm
                :procedimientos="activeProcedimientos"
                @add-procedimiento="addProcedimiento"
                :readonly="readonly"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <TextButton
          v-if="!readonly"
          color="secondary"
          @click="triggerSaveDisciplinaOperativa()"
          :loading="loading"
          :disabled="loading"
          >Guardar evaluación</TextButton
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import InformacionGeneralEvaluacionSection from './evaluacion-desempeño/common/InformacionGeneralEvaluacionSection.vue'
import ProcedimientosForm from './evaluacion-desempeño/disciplina-operativa/forms/ProcedimientosForm.vue'
import ProcedimientosCountersSection from './evaluacion-desempeño/disciplina-operativa/section/ProcedimientosCountersSection.vue'
import UpdateEvaluacionDisciplinaOperativaUseCase from '@modules/evaluacion-desempeño/application/usecases/UpdateEvaluacionDisciplinaOperativa.usecase'
import UpdateEvaluacionDisciplinaOperativaRepository from '@modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaOperativaApi.repository'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: { InformacionGeneralEvaluacionSection, ProcedimientosForm, ProcedimientosCountersSection, TextButton },

  props: {
    active: {
      type: Boolean,
      default: false,
    },

    disciplinaOperativa: {
      type: Object,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    await this.fetchEstatusProcedimiento()
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    activeProcedimientos() {
      return this.disciplinaOperativa.procedimientos.filter(({ estatus }) => Boolean(estatus))
    },
  },

  methods: {
    ...mapActions('disciplinaOperativa', ['updateDisciplinaOperativa']),
    ...mapActions('estatusProcedimiento', ['fetchEstatusProcedimiento']),

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },

    async triggerSaveDisciplinaOperativa() {
      this.loading = true

      await new UpdateEvaluacionDisciplinaOperativaUseCase(new UpdateEvaluacionDisciplinaOperativaRepository()).execute(
        this.disciplinaOperativa
      )

      this.closeDialog()
    },

    addProcedimiento(procedimiento) {
      this.disciplinaOperativa.procedimientos.push(procedimiento)
    },
  },
}
</script>
